export class UpdateUser {
  constructor(
    public userName: string,
    public emailId: string,
    public password: string,
    public firstname: string,
    public lastname: string
  ) {}
}
